import React from 'react';
import { PropsRoute } from '../components/router/PropsRoute';
import { matchPath } from 'react-router';

export const mapRoutes = routes =>
    routes ? routes.map((route, index) => <PropsRoute key={index} {...route} />) : [];

/**
 * Add local before each localizableRoutes path
 * return an array with all routes prefix by a locale
 */
export const localizeRoutes = (locales, routes) =>
    locales.reduce((res, locale) => {
        const currentLocaleRoutes = routes.map(route => {
            const path = route.path ? { path: `/${locale}${route.path}` } : {};
            const to = route.to ? { to: `/${locale}${route.to}` } : {};
            return { ...route, ...path, ...to };
        });
        return [ ...res, ...currentLocaleRoutes ];
    }, []);

/**
 * Return true if the path match the current location
 * @param {*} path the path to test
 * @param {*} location the location object inject by hoc withRouter
 */
export const isRouteActive = (path, location) =>
    path && location && matchPath(location.pathname, { path }) != null;



// WEBPACK FOOTER //
// ./src/utils/routeUtils.js